module.exports = __webpack_public_path__ + "75b1109d75f099583b835d4b113bbfcb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/purse-s.png
// module id = 2594
// module chunks = 0